import React from "react"
//import I18n from "i18n-js/index.js.erb"
import DateHelper from "../../DateHelper/DateHelper"

class FolioBuilderPaymentSummaryRow extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var self = this;
    var date = this.props.payment.processed_at
    var payment = this.props.payment
    var card = this.props.payment.card
    var description = `${I18n.t('paid')} ${card.brand} XXXXXXXXXXXX${card.last_4}`
    var amount = this.props.payment.amount

    var row = [
      <td className="processed_at" key={this.props.payment.processed_at}>{DateHelper.parseDate(date).toString(DateHelper.rubyToDateJS(self.props.date_format))}</td>,
      <td className="description" key={this.props.payment.id}>{description}</td>,
      <td className="amount" key={this.props.payment.amount}>{self.props.formatCurrency(amount)}</td>
    ]

    return(
      <tr>
        {row}
      </tr>
    )
  }
}

export default FolioBuilderPaymentSummaryRow